module.exports = __webpack_public_path__ + "static/quote-bfa1e63dafdb47ec9ea0487341e8debe.png";